module.exports = __webpack_public_path__ + "banquet/components/InventoryRecordListElement/images/button_heart.a7f791dce0ac27aac8e11f386abd1d55.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordListElement/images/button_heart.svg
// module id = 1677
// module chunks = 1